<div style="margin-bottom: 12px;">Test QC {{title}}</div>
<div nz-row>
    <div class="patient-info">
        <img src="assets/dynacare.png" alt="dynacare-img" class="logo" />

        <p>PATIENT:</p>
        <div nz-row class="row">
            <div nz-col nzSpan="6">Name</div>
            <div nz-col nzSpan="6">{{user?.lastName}}</div>
            <div nz-col nzSpan="3">First Name</div>
            <div nz-col nzSpan="3">{{user?.firstName}}</div>
            <div nz-col nzSpan="6">D.O.B: {{user?.dob}}</div>
        </div>
        <div nz-row class="row">
            <div nz-col nzSpan="6">Address</div>
            <div nz-col nzSpan="6">{{user?.defaultAddress?.address1}}</div>
            <div nz-col nzSpan="6">Suite</div>
            <div nz-col nzSpan="6"></div>
        </div>
        <div nz-row class="row">
            <div nz-col nzSpan="6">City</div>
            <div nz-col nzSpan="6">{{user?.defaultAddress?.city}}</div>
            <div nz-col nzSpan="6">Postal Code</div>
            <div nz-col nzSpan="6">{{user?.defaultAddress?.postalCode}}</div>
        </div>
        <div nz-row class="row">
            <div nz-col nzSpan="6">Home T</div>
            <div nz-col nzSpan="6">{{user?.phone}}</div>
            <div nz-col nzSpan="6">Mobile T</div>
            <div nz-col nzSpan="6"></div>
        </div>
        <div nz-row class="row">
            <div nz-col nzSpan="9">#Health Insurance # (if required)</div>
            <div nz-col nzSpan="9"></div>
            <div nz-col nzSpan="3">Sex</div>
            <div nz-col nzSpan="3"></div>
        </div>
    </div>
    <div style="width: 50%;">
        <div class="info-container">
            <p style="color: rgb(131, 190, 55); font-size: 16px;">
                Information for collection agency only
            </p>
            <div nz-row class="info-row">
                <div nz-col nzSpan="7">Collection Date:</div>
                <div nz-col nzSpan="7" class="underline"></div>
                <div nz-col nzSpan="5">Time:</div>
                <div nz-col nzSpan="5" class="underline"></div>
            </div>
            <div nz-row class="info-row">
                <div nz-col nzSpan="7">Collected by:</div>
                <div nz-col nzSpan="7" class="underline"></div>
                <div nz-col nzSpan="5">Account #:</div>
                <div nz-col nzSpan="5" class="underline"></div>
            </div>
        </div>
        <div class="info-container">
            <div nz-row class="info-row">
                <span>CLIENT # :</span>
                <div nz-col nzSpan="18" class="underline"></div>
            </div>
            <div nz-row class="info-row">
                <div nz-col nzSpan="14">
                    <span>DOCTOR:</span>
                    <div class="underline"></div>
                </div>
                <div nz-col nzSpan="10">
                    <span>#PERMIT:</span>
                    <div class="underline"></div>
                </div>
            </div>
            <div nz-row class="info-row">
                <span>Clinic:</span>
                <div nz-col nzSpan="20" class="underline"></div>
            </div>
            <div nz-row class="info-row">
                <span>Address:</span>
                <div nz-col nzSpan="20" class="underline"></div>
            </div>
            <div nz-row class="info-row">
                <div nz-col nzSpan="12">
                    <span>T:</span>
                    <div class="underline"></div>
                </div>
                <div nz-col nzSpan="12">
                    <span>F:</span>
                    <div class="underline"></div>
                </div>
            </div>
            <div nz-row class="info-row">
                <div nz-col nzSpan="14">
                    <span>Dr. SIGNATURE :</span>
                    <div class="underline"></div>
                </div>
                <div nz-col nzSpan="10">
                    <span>Date:</span>
                    <div class="underline">AAAA/MM/DD</div>
                </div>
            </div>
            <div nz-row class="info-row">
                <div nz-col nzSpan="15">
                    <span>Copy to Dr.:</span>
                    <div class="underline"></div>
                </div>
                <div nz-col nzSpan="9">
                    <span>F:</span>
                    <div class="underline"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div nz-row>
    <div style="width: 50%;">
        <h4 class="items-header">
            PROFILES
        </h4>
        <div nz-row>
            <div nz-col nzSpan="12">
                <my-health-input-group
                    [title]=""
                    testId="profiles-section1"
                    [options]="fields1"
                    [values]="values"
                    [headerStyle]="headerStyle"
                    [inputColor]="inputColor"
                ></my-health-input-group>
            </div>
            <div nz-col nzSpan="12">
                <my-health-input-group
                    [title]=""
                    testId="profiles-section2"
                    [options]="fields2"
                    [values]="values"
                    [headerStyle]="headerStyle"
                    [inputColor]="inputColor"
                ></my-health-input-group>
            </div>
        </div>
        <div>
            <h4 *ngIf="title" class="title-specification">
                Test Specification
            </h4>
            <div nz-row>
                <div nz-col nzSpan="15">
                    <my-health-input-group
                        [title]=""
                        testId="test-specification"
                        [options]="fields5"
                        [values]="values"
                        [headerStyle]="headerStyle"
                        [inputColor]="inputColor"
                    ></my-health-input-group>
                </div>
                <div nz-col nzSpan="9">
                    <my-health-input-group
                        [title]=""
                        testId="test-specify-source"
                        [options]="fields6"
                        [values]="values"
                        [headerStyle]="headerStyle"
                        [inputColor]="inputColor"
                    ></my-health-input-group>
                </div>
            </div>
        </div>
        <div class="card padded">
            <h4 style="font-size: 16px;">
                Other Analyses / Instructions:
            </h4>
            <input nz-input type="text" class="other-input" />
            <input nz-input type="text" class="other-input" />
            <input nz-input type="text" class="other-input" />
        </div>
        <div class="card padded">
            <p class="info-profiles">
                No food or alcohol for 12 hours before collection. Water is
                permitted. ≠, § For more information visit Dynacare.ca or by
                calling our customer care team at 800.565.5721.
            </p>
        </div>
    </div>
    <div style="width: 50%;">
        <h4 class="items-header">
            INDIVIDUAL ANALYSES
        </h4>
        <div nz-row>
            <div nz-col nzSpan="12">
                <my-health-input-group
                    [title]=""
                    testId="individual-section1"
                    [options]="fields3"
                    [values]="values"
                    [headerStyle]="headerStyle"
                    inputColor="#646464"
                ></my-health-input-group>
            </div>
            <div nz-col nzSpan="12">
                <my-health-input-group
                    [title]=""
                    testId="individual-section2"
                    [options]="fields4"
                    [values]="values"
                    [headerStyle]="headerStyle"
                    inputColor="#646464"
                ></my-health-input-group>
            </div>
        </div>
    </div>
</div>
